//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfSearchBar from '~/themes/fiskarsMoominDefault/components/components/molecules/SfSearchBar/SfSearchBar.vue';
import SfBar from '~/themes/fiskarsMoominDefault/components/components/molecules/SfBar/SfBar.vue';
import MoominHeaderSearchSuggestions from './_internal/MoominHeaderSearchSuggestions.vue';
import {ref, onMounted, watch, useRoute} from '@nuxtjs/composition-api';
import { clickOutside } from '~/themes/fiskarsMoominDefault/components/utilities/directives/click-outside/click-outside-directive.js';
import SfIcon from '../../atoms/SfIcon/SfIcon.vue';

export default {
  name: 'MoominHeaderSearch',
  components: {
    SfBar,
    SfSearchBar,
    MoominHeaderSearchSuggestions,
    SfIcon
  },
  props: {
    placeholder: {
      type: String,
    },
    term: {
      type: String,
    },
    showSearchSuggestions: {
      type: Boolean,
      defualt: false
    },
    isValid: {
      type: Boolean,
      defualt: true
    },
    errorMessage:{
      type: String
    },
    crossIcon: {
      type: [Object, String]
    },
    suggestionsPlaceholder: {
      type: String
    },
    topSearchesPlaceholder: {
      type: String
    },
    noSuggestionsPlaceholder: {
      type: String
    },
    searchSuggestions: {
      type: Array
    },
    isSearchOpen: {
      type: Boolean,
    }
  },
  directives: { clickOutside },
  setup(props, { emit }) {
    const searchBarRef = ref(null);
    const route = useRoute();

    const closeSearchOnEscape = (event) => {
      if (!props.isSearchOpen) return;
      if (!event || event.key === 'Escape' || event.key === 'Tab') {
        emit('closeSearchOnEscape')
      }
    };

    const emitIconClick = () => {
      emit('emitIconClick')

      const inputElement = searchBarRef.value.$el.querySelector('input');
      inputElement.focus();
    }

    const focusSearchInput = () => {
      if (searchBarRef.value) {
        const inputElement = searchBarRef.value.$el.querySelector('input');
        if (inputElement) {
          inputElement.focus();
          // Also emit openSearchModal to ensure search is open
          emit('openSearchModal');
        }
      }
    };

    const checkHashAndFocus = () => {
      if (route.value.hash === '#search') {
        focusSearchInput();
      }
    }

    // Watch for route changes
    watch(() => route.value.hash, (newHash) => {
        checkHashAndFocus();
    });

    onMounted(() => {
        checkHashAndFocus()
        if (props.isSearchOpen) {
          emit('closeSearchOnEscape');
        }
    });

    return {
      closeSearchOnEscape,
      searchBarRef,
      emitIconClick
    }
  }
};
